import React, {useEffect, useState, useContext} from 'react'
import PropTypes from 'prop-types'
import CountrySelector from "../country-selector/country-selector";
import { CountryContext } from '../../contexts/country-context';
import Flag from 'react-world-flags'



const CountryInput = ({ country, value, name, id, onChange, getCountry, exclude, useDefault, label , disabled}) => {
    const countryValue = useContext(CountryContext)
    const useDef = useDefault || false
    const countriesFULL = countryValue?.fullCountryList
    const BE = countryValue?.defalutCountry
    // const initDefaultCountry = useDef ? BE : countriesFULL.filter(ct => exclude && exclude.every(ex => ct.code !== ex ))[0]
    const initDefaultCountry = useDef ? BE : {}
    const initSelctedCountry = value ? {
            callingCode: value.callingCode ,
            name: value.name ,
            code: value.code ,
    } : {
            callingCode: initDefaultCountry?.callingCode,
            name: initDefaultCountry?.name,
            code: initDefaultCountry?.code,
    }

    const [defaultCountry] = useState( initDefaultCountry)
    const [inputValue] = useState(value)
    const [showCountryList, setShowCountryList] = useState(false)
    const [selectedCountry, setSelectedCountry] = useState(initSelctedCountry)

    // console.log("inputValue => ", inputValue)
    // console.log("defaultCountry => ", defaultCountry)
    // console.log("initDefaultCountry => ", initDefaultCountry)
    // console.log("useDef => ", useDef)
    // console.log("BE => ", BE)
    // console.log("countriesFULL[0] => ", countriesFULL?.[0])

    const handleInputChange = (e) => {
        // onChange(e)
    }

    const setCountry = (country) => {
        const cnt = country.name.replace("<b>", "").replace("</b>", "")
        const __country = {
            callingCode: country.callingCode,
            code: country.code,
            country: cnt.charAt(0).toUpperCase() + cnt.slice(1),
            name: cnt.charAt(0).toUpperCase() + cnt.slice(1)
        }
        setSelectedCountry(__country)
        getCountry(name, __country)

    }

    useEffect(() => {
        if (inputValue) {
            const __country = {
                callingCode: inputValue.callingCode,
                code: inputValue.code,
                country: inputValue.country,
                name: inputValue.country
            }
            setSelectedCountry(__country)
            getCountry(name, __country)
        }
    }, [inputValue])

    return (
        <>
            <div className={"textField "}>
                <label className={"country-input"}>
                    <span className='flag'>
                        <Flag code={selectedCountry.code}  />
                    </span>
             
                    <input
                        placeholder=" "
                        type={"text"}
                        name={name}
                        id={name}
                        value={selectedCountry.name}
                        code={selectedCountry.code}
                        onChange={handleInputChange}
                        onClick={() => { setShowCountryList(true) }}
                        autocomplete="off"
                        disabled={disabled}
                    />
                    <span>{label}</span> 
                </label>
            </div>

          

            {showCountryList && !disabled &&
                <CountrySelector
                    phoneCode={false}
                    title={"Code du pays"}
                    selected={selectedCountry.code}
                    close={() => {setShowCountryList(false)}}
                    getCountry={setCountry}
                    exclude={exclude}
                />}

        </>
    )
}


CountryInput.propTypes = {
    defaultCountry: PropTypes.string,
    value: PropTypes.any,
    name: PropTypes.string,
    id: PropTypes.string,
    onChange: PropTypes.func,
    getCountry: PropTypes.func,
    country: PropTypes.any,
};

export default CountryInput